(function () {
  document.querySelectorAll('[data-bz-mnav-summary]').forEach(function (summary) {
    var details = summary.closest('details');
    if (!details || details.dataset.bzMnavBound === 'true') return;
    details.dataset.bzMnavBound = 'true';

    function syncExpanded() {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }

    syncExpanded();
    details.addEventListener('toggle', syncExpanded);
  });
})();
